/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    equalWidth: {
      description: 'Divide the available width equally among `TabsItem`',
      type: 'variant',
      values: [ true ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { selected: true },
      tokens: {
        color: '#394056',
        highlightBarBorderWidth: 4,
        highlightBarHeight: 1,
        highlightColor: '#f39d80'
      }
    },
    { if: { hover: true }, tokens: { color: '#636c8c' } },
    {
      if: { focus: true },
      tokens: { borderColor: '#394056', borderWidth: 1, color: '#394056' }
    },
    {
      if: { pressed: true },
      tokens: { borderWidth: 0, color: '#2b3145' }
    },
    {
      if: { inverse: true },
      tokens: { backgroundColor: 'transparent', color: '#f9f2dd' }
    },
    {
      if: { inverse: true, selected: true },
      tokens: {
        color: '#f9f2dd',
        highlightBarBorderWidth: 4,
        highlightBarHeight: 1,
        highlightColor: '#f9f2dd'
      }
    },
    {
      if: { hover: true, inverse: true },
      tokens: { color: '#f9cebf' }
    },
    {
      if: { focus: true, inverse: true },
      tokens: { borderColor: '#f9f2dd', color: '#f9f2dd' }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: { color: '#f39d80' }
    },
    { if: { equalWidth: true }, tokens: { maxWidth: null } }
  ],
  tokens: {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    borderRadius: 0,
    borderWidth: 0,
    color: '#394056',
    fontName: 'SofiaPro',
    fontScaleCap: 64,
    fontSize: 16,
    fontWeight: '700',
    highlightBarBorderRadius: 0,
    highlightBarBorderWidth: 0,
    highlightBarHeight: 0,
    highlightColor: 'transparent',
    highlightTriangleSize: 0,
    letterSpacing: 0,
    lineHeight: 1.5,
    marginHorizontal: 0,
    marginVertical: 0,
    maxWidth: null,
    paddingHorizontal: 24,
    paddingVertical: 12,
    space: 0,
    textAlign: 'center',
    textTransform: 'none'
  }
}
export default theme
